import React from 'react';
import { createPortal } from 'react-dom';
import { Loader2 } from 'lucide-react';

export default function InvoiceProcessing({ message }) {
    // Keep the indicator outside the module's scrolling and filtered canvas.
    return createPortal(<div className="esave-workspace esave-progress-overlay">
        <div className="esave-progress" role="status" aria-live="polite" aria-atomic="true">
            <Loader2 size={28} className="animate-spin" aria-hidden="true" />
            <p>{message}</p>
        </div>
    </div>, document.body);
}
